export default {
  mainhost: "//www.webinterpret.{location}",
  portal: "//portal.webinterpret.com",
  portalAdminEbay: "//wi-mother-admin.webinterpret.com",
  portalAdminAmazon: "http://wi-amazon-admin.devwebinterpret.com",
  host: "//api.webinterpret.{location}",
  gatewayHost: "//gateway.webinterpret.{location}",
  shippingHost: "//shipping.webinterpret.com",
  mother: "//portal.webinterpret.com",
  paypalHost: "//www.paypal.com",
  env: "production",
  release: "6.29.4",
  zendeskHost: "//webinterpret.zendesk.com",
}
